import { createContext } from 'react';

import type { FeatureFlagsContextProps } from './types';

const FeatureFlagsContext = createContext<FeatureFlagsContextProps | undefined>(
  undefined
);

export default FeatureFlagsContext;
